import React from "react";
import { ArrowRight } from "lucide-react";
import { JOTFORM_URL, NAV_LINKS, CONTACT_EMAIL, EMAIL_COMPOSE_URL, WHATSAPP_URL } from "../constants";
import { useSite } from "../contexts/SiteContext";

const Footer = () => {
  const { content } = useSite();
  const footer = content.footer || {};
  return (
    <footer style={{ background: "#14103F", color: "#fff", padding: "64px 24px 32px" }}>
      <div
        style={{ maxWidth: 1240, margin: "0 auto", display: "grid", gridTemplateColumns: "1.2fr 1fr 1fr", gap: 48, marginBottom: 40 }}
        className="footer-grid"
      >
        <div>
          <a href="#top" style={{ display: "inline-flex", alignItems: "center", gap: 10, textDecoration: "none", marginBottom: 16 }}>
            <span style={{ width: 34, height: 34, borderRadius: 10, background: "linear-gradient(135deg,#5446EA,#C04ABF)", display: "inline-flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 800, fontSize: 16 }}>AE</span>
            <span style={{ color: "#fff", fontWeight: 800, fontSize: 18 }}>Active<span style={{ color: "#A89BFF" }}>English</span></span>
          </a>
          <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 14, lineHeight: 1.6, maxWidth: 360 }}>{footer.tagline}</p>
        </div>

        <div>
          <h4 style={{ fontSize: 13, textTransform: "uppercase", letterSpacing: "0.08em", color: "rgba(255,255,255,0.6)", margin: "0 0 14px" }}>Navegación</h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 10 }}>
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} style={{ color: "#fff", textDecoration: "none", fontSize: 14, opacity: 0.85 }}>{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 style={{ fontSize: 13, textTransform: "uppercase", letterSpacing: "0.08em", color: "rgba(255,255,255,0.6)", margin: "0 0 14px" }}>Contacto</h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 10 }}>
            <li>
              <a href={EMAIL_COMPOSE_URL} target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "none", fontSize: 14, opacity: 0.85 }}>{CONTACT_EMAIL}</a>
            </li>
            <li>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "none", fontSize: 14, opacity: 0.85 }}>WhatsApp</a>
            </li>
          </ul>
          <a href={JOTFORM_URL} target="_blank" rel="noopener noreferrer" className="btn-orange" style={{ marginTop: 18 }}>
            Empieza ahora <ArrowRight size={15} />
          </a>
        </div>
      </div>

      <div style={{ borderTop: "1px solid rgba(255,255,255,0.1)", paddingTop: 24, maxWidth: 1240, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
        <span style={{ color: "rgba(255,255,255,0.5)", fontSize: 13 }}>
          © {new Date().getFullYear()} ActiveEnglish. Todos los derechos reservados.
        </span>
        <span style={{ color: "rgba(255,255,255,0.5)", fontSize: 13 }}>{footer.rightsText}</span>
        <a href="/admin/login" style={{ color: "rgba(255,255,255,0.3)", fontSize: 11, textDecoration: "none", letterSpacing: "0.06em" }} title="Administrador">
          · admin
        </a>
      </div>

      <style>{`@media (max-width: 800px){.footer-grid{grid-template-columns:1fr !important;gap:28px !important;}}`}</style>
    </footer>
  );
};

export default Footer;
